var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTutorial(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4146_5)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 25,
    width: 21,
    height: 3,
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.5 27C19.2114 26.2 16.8727 25.5882 15.25 25.5882C13.675 25.5882 12.0523 25.8706 10.7159 26.5765C10.6205 26.6235 10.5727 26.6235 10.4773 26.6235C10.2386 26.6235 10 26.3882 10 26.1529V12.4118C10.5727 11.9882 11.1932 11.7059 11.9091 11.4706C12.9686 11.1412 14.1332 11 15.25 11C17.1114 11 19.1159 11.3765 20.5 12.4118C21.8841 11.3765 23.8886 11 25.75 11C26.8668 11 28.0314 11.1412 29.0909 11.4706C29.8068 11.7059 30.4273 11.9882 31 12.4118V26.1529C31 26.3882 30.7614 26.6235 30.5227 26.6235C30.4273 26.6235 30.3795 26.6235 30.2841 26.5765C28.9477 25.8706 27.325 25.5882 25.75 25.5882C24.1273 25.5882 21.7886 26.2 20.5 27ZM19.5455 13.8235C18.2473 13.2588 16.5291 12.8824 15.25 12.8824C14.1045 12.8824 12.9591 13.0235 11.9091 13.3529V24.1765C12.9591 23.8471 15.25 23.8783 15.25 23.8783C15.25 23.8783 18.2473 24.0824 19.5455 24.6471V13.8235ZM21.4545 24.6471C22.7527 24.0824 24.4709 23.7059 25.75 23.7059C26.8955 23.7059 28.0409 23.8471 29.0909 24.1765V13.3529C28.0409 13.0235 26.8955 12.8824 25.75 12.8824C24.4709 12.8824 22.7527 13.2588 21.4545 13.8235V24.6471Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27 19L24.75 20.299L24.75 17.701L27 19Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1818 18.2727H19V18.7273H18.1818V18.2727ZM13 18.2727H13.8182V18.7273H13V18.2727ZM16.2727 16V16.6818H15.7273V16H16.2727ZM14.0691 16.5682L14.65 17.0545L14.2627 17.375L13.6818 16.8932L14.0691 16.5682ZM17.35 17.0523L17.9282 16.5682L18.3182 16.8932L17.7373 17.375L17.35 17.0523ZM16 17.1364C16.434 17.1364 16.8502 17.28 17.1571 17.5358C17.464 17.7915 17.6364 18.1383 17.6364 18.5C17.6364 19.0045 17.3064 19.4455 16.8182 19.6818V20.0909C16.8182 20.1512 16.7894 20.209 16.7383 20.2516C16.6872 20.2942 16.6178 20.3182 16.5455 20.3182H15.4545C15.3822 20.3182 15.3128 20.2942 15.2617 20.2516C15.2106 20.209 15.1818 20.1512 15.1818 20.0909V19.6818C14.6936 19.4455 14.3636 19.0045 14.3636 18.5C14.3636 18.1383 14.536 17.7915 14.8429 17.5358C15.1498 17.28 15.566 17.1364 16 17.1364ZM16.5455 20.5455V20.7727C16.5455 20.833 16.5167 20.8908 16.4656 20.9334C16.4144 20.9761 16.3451 21 16.2727 21H15.7273C15.6549 21 15.5856 20.9761 15.5344 20.9334C15.4833 20.8908 15.4545 20.833 15.4545 20.7727V20.5455H16.5455ZM15.7273 19.8636H16.2727V19.3795C16.7445 19.2795 17.0909 18.9227 17.0909 18.5C17.0909 18.2589 16.976 18.0277 16.7714 17.8572C16.5668 17.6867 16.2893 17.5909 16 17.5909C15.7107 17.5909 15.4332 17.6867 15.2286 17.8572C15.024 18.0277 14.9091 18.2589 14.9091 18.5C14.9091 18.9227 15.2555 19.2795 15.7273 19.3795V19.8636Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19,
    stroke: "#A6A6A6",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4146_5"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTutorial);
export default __webpack_public_path__ + "static/media/tutorial.fd21d5bcd4442a59aa5657064c16ec13.svg";
export { ForwardRef as ReactComponent };